import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import StateSiteUserAdvertiser from "./StateSiteUserAdvertiser";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";

export default function InfoSiteUserAdvertiser({ siteUserAdvertiser }) {
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const htmlTag = `<script class="hilite-script" data-hilite="${siteUserAdvertiser.hashIDScript}" src="https://unpkg.com/hilite-script-site-publisher@latest/dist/script.min.js"></script>`;

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendAskReCheckWebSite = async (siteUserAdvertiserID) => {
    setShow(false);
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestSendAskReCheckWebSite =
      await sendRequestSendAskReCheckWebSite(siteUserAdvertiserID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestSendAskReCheckWebSite) {
      return;
    }
    window.location.reload();
  };

  const sendRequestSendAskReCheckWebSite = async (siteUserAdvertiserID) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-user-advertiser/" +
          siteUserAdvertiserID +
          "/ask-admin-recheck",
        {},
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateMessage = (siteUserAdvertiserID, message) => {
    return (
      <div>
        <div>دلیل رد شدن سایت شما : </div>
        <div className="pb-2">
          <p className="m-0 alert alert-danger">{message}</p>
        </div>
        <div className="alert alert-warning ">
          <p>
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p>
                {" "}
                در صورتیکه مشکل را برطرف نموده اید , بوسیله دکمه زیر درخواست
                بررسی دوباره سایت خود را ارسال کنید.
              </p>
            </li>
          </ul>
        </div>
        <div>
          <button
            className="btn btn-primary"
            onClick={(e) => {
              e.preventDefault();
              sendAskReCheckWebSite(siteUserAdvertiserID);
            }}
          >
            ارسال درخواست بررسی مجدد
          </button>
        </div>
      </div>
    );
  };

  const generateScriptPart = () => {
    return (
      <>
        <div className="pb-4 d-flex">
          <div className="pr-2">
            برای استفاده از پلتفرم تبلیغاتی هایلات این تگ اسکریپت را در بخش head
            سایت خود درج کنید.
          </div>
          <div>
            <button
              className="btn btn-outline-info"
              onClick={(e) => {
                e.preventDefault();
                navigator.clipboard.writeText(htmlTag);
                setCopied(true);
              }}
            >
              <i className="fas fa-copy pl-2"></i>
              {copied ? "کپی شد" : " کپی  "}{" "}
            </button>
          </div>
        </div>
        <div dir="ltr">
          <pre className="p-2" style={{ color: "crimson !important" }}>
            <code>{htmlTag}</code>
          </pre>
        </div>
      </>
    );
  };

  return (
    <>
      <Button variant="primary" className="btn btn-info" onClick={handleShow}>
        توضیحات
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        id="modal-hilite-script"
      >
        <Modal.Header closeButton>
          <Modal.Title>توضیحات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {generateScriptPart()}
          <hr />
          {siteUserAdvertiser.state ==
          StateSiteUserAdvertiser.statusSiteUserAdvertiser.REJECT ? (
            generateMessage(siteUserAdvertiser.id, siteUserAdvertiser.message)
          ) : (
            <></>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
